export const getEmptyUrlGeneratorMap = () => ({
    routes: {},
});
//# sourceMappingURL=emptyUrlGeneratorMap.js.map